import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthUsersGuard} from '../../../resources/guards/authUsers.guard';
import {StoreCollectionEditComponent} from '../../store-collection/store-collection-edit/store-collection-edit.component';
import {StoreCollectionCreateComponent} from '../../store-collection/store-collection-create/store-collection-create.component';
import {StoreCollectionIndexComponent} from '../../store-collection/store-collection-index/store-collection-index.component';
import {StoreCollectionComponent} from '../../store-collection/store-collection.component';
import {StoreVersionEditComponent} from '../../store-version/store-version-edit/store-version-edit.component';
import {StoreCollectionViewComponent} from '../store-collection-view/store-collection-view.component';
import {StoreCollectionViewRoutes} from '../store-collection-view/store-collection-view.routes';
import {FormChangesGuard} from '../../../resources/guards/formChanges.guard';
import {routerHandler} from '../../../resources/utils/router';
import {ProjectIndexComponent} from '../../projects/project-index/project-index.component';
import {ProjectCreateComponent} from '../../projects/project-create/project-create.component';
import {ProjectViewComponent} from '../../projects/project-view/project-view.component';
import {ProjectViewRoutes} from '../../projects/project-view/project-view.routes';

export const StoreCollectionRoutes: Routes = [

  {
    path: 'store-collections',
    data: {
      hidden: true,
      title: 'Store collections',
    },
    component: StoreCollectionComponent,
    canActivate: [AuthUsersGuard],
    canDeactivate: [FormChangesGuard],
    children: [
      routerHandler.index('store-collection', {component: StoreCollectionIndexComponent}),
      routerHandler.create('store-collection', {component: StoreCollectionCreateComponent}),
      routerHandler.view('store-collection', {component: StoreCollectionViewComponent, children: StoreCollectionViewRoutes}),
    ],
  },

];

@NgModule({
  imports: [RouterModule.forChild(StoreCollectionRoutes)],
  exports: [RouterModule]
})
export class StoreCollectionRoutesModule {
}
